import {
  Avatar,
  Badge,
  Button,
  Divider,
  Dropdown,
  DropdownActions,
  InputEnhancement,
  InputNumber,
  InputText,
  Pin,
  Popover,
  Spinner,
  Table,
  TableTop,
  Tabs,
  UILibrary,
} from "@coolrunner/ui-library";
import useDate from "~/composables/useDate";
import { useFormatPrice } from "~/composables/usePrice";
import { useFormatWeight } from "~/composables/useWeight";

export default defineNuxtPlugin((nuxtApp) => {
  // The table formats its date, price and weight cells through these, so they read as the rest of the app
  const i18n = nuxtApp.$i18n as ReturnType<typeof useI18n>;
  nuxtApp.vueApp.use(UILibrary, {
    locale: String(i18n.locale.value),
    formatters: {
      formatPrice: (price, decimals, currency) => useFormatPrice(price, decimals, currency),
      formatWeight: (weight, options) => useFormatWeight(weight, options) ?? "",
      formatDate: (date, options) => useDate().formatDate(date, options),
    },
  });

  // Only what is in use: the order packing flow, plus Pin and Spinner used elsewhere.
  // Register all UI library components with "HR" prefix
  const components = {
    Avatar,
    Badge,
    Button,
    Divider,
    Dropdown,
    DropdownActions,
    InputEnhancement,
    InputNumber,
    InputText,
    Pin,
    Popover,
    Spinner,
    Table,
    TableTop,
    Tabs,
  };

  Object.entries(components).forEach(([name, component]) => {
    nuxtApp.vueApp.component(`HR${name}`, component);
  });
});
